<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />

    <new-type-of-hosting @created="getTypeOfHostings" />
    <view-type-of-hosting
      :type_of_hosting="type_of_hosting"
      :finance_configuration_category="finance_configuration_category"
      @updated="getTypeOfHostings"
      @close="type_of_hosting = null"
    />

    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <div class="row">
          <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 pt-0">
            <v-btn class="btn-return" @click="$router.go(-1)">
              <i class="fas fa-arrow-left mr-2 text-twenty"> </i> Voltar
            </v-btn>
          </div>
          <div class="col-xl-5 col-lg-5 col-md-6 col-sm-9 col-12 pt-0">
            <h1 class="title-pages pt-1 check-text-center">
              TIPOS DE HOSPEDAGENS
            </h1>
          </div>
          <div
            class="col-xl-6 col-lg-5 col-md-4 col-sm-12 col-12 pt-0 text-right"
          >
            <v-btn
              v-if="permission('write', 'type_of_hosting')"
              class="btn-add"
              @click="$bvModal.show('new_type_of_hosting')"
            >
              <i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR
            </v-btn>
          </div>
          <div class="col-xl-3 col-lg-4 col-md-5 col-sm-6 col-12 pb-0 pt-0">
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              placeholder="Pesquisar tipos de hospedagens"
              outlined
              dense
            />
          </div>
        </div>
        <div
          class="v-clean p-5 text-center"
          v-show="typeOfHostings.length == 0"
        >
          <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
        </div>
        <v-data-table
          v-show="typeOfHostings.length > 0"
          v-if="permission('read', 'type_of_hosting')"
          dense
          :headers="headers"
          :items="typeOfHostings"
          :search="search"
          :footer-props="{
            'items-per-page-options': [50, 75, 100],
            'items-per-page-text': 'Mostrar',
          }"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn small @click="type_of_hosting = item" class="btn-edit m-1">
              <i class="fas fa-pen mr-2 text-twenty"></i>
              EDITAR
            </v-btn>
          </template>
        </v-data-table>
        <ErrorsMessages :errors="errors" />
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import ErrorsMessages from "../templates/Components/ErrorsMessages";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import api from "../services/api";

import permission from "../lib/permission";

import NewTypeOfHosting from "../templates/types-of-hosting/new-type-of-hosting.vue";
import ViewTypeOfHosting from "../templates/types-of-hosting/view-type-of-hosting.vue";
import { getRestHomeSelectedFinancialAccount } from "../lib/functions";

export default {
  name: "RestHomeTypeOfHosting",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    NewTypeOfHosting,
    ViewTypeOfHosting,
  },

  data() {
    return {
      errors: [],
      loading: false,

      type_of_hosting: null,

      search: "",
      headers: [
        {
          text: "TIPO DE COBRANÇA",
          value: "billing_type_of_hosting_type_name",
        },
        { text: "NOME", value: "name" },
        { text: "AÇÕES", value: "actions" },
      ],
      typeOfHostings: [],
      finance_configuration_category: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    getRestHomeSelectedFinancialAccount,
    permission,

    async retrieve() {
      if (this.errors.length == 0) await this.getTypeOfHostings();
      if (this.errors.length == 0) await this.financeConfigurationCategory();
      // if (this.errors.length == 0) await this.getBillingTypeOfHostingTypes();
    },

    async getTypeOfHostings() {
      try {
        this.loading = true;

        const response = await api.get("/rest-home/type-of-hosting/paginate");
        const { error, errors, types } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.typeOfHostings = types;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async financeConfigurationCategory() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get(
          "/rest-home/financial/configuration/category-actives",
          {
            params,
          }
        );

        const { data } = response.data;

        this.finance_configuration_category = data;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
